import { Stack } from "@mui/material";
import CogsTable from "./table";
import { InventoryPermissions } from "src/constants/permissions";
import { oneBranchHasPermission } from "src/utils";

const RecipeCost = () => {
  // permissions
  const addPermission = oneBranchHasPermission(InventoryPermissions.addCogs);

  return (
    <Stack spacing={3}>
      <CogsTable />
    </Stack>
  );
};

export default RecipeCost;
